import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useCopilot } from '../hooks/useCopilot'
import { SessionState } from '../state/types'

export function ConfirmationCard({ session }: Readonly<{ session: SessionState }>) {
  const { t } = useTranslation()
  const { confirm } = useCopilot()
  const [declining, setDeclining] = useState(false)
  const [reason, setReason] = useState('')
  const c = session.pendingConfirmation
  if (!c) return null

  return (
    <div className="copilot-railcard copilot-railcard--warn">
      <span className="copilot-railcard__kicker">{t('copilot.confirm.kicker')}</span>
      <p>{c.summary}</p>
      {!declining ? (
        <div className="copilot-railcard__actions">
          <button
            type="button"
            className="btn btn-sm btn-primary"
            data-testid="copilot-approve"
            onClick={() => confirm(session.clientId, true, undefined)}
          >
            {t('copilot.confirm.approve')}
          </button>
          <button
            type="button"
            className="btn btn-sm btn-outline-danger"
            data-testid="copilot-decline"
            onClick={() => setDeclining(true)}
          >
            {t('copilot.confirm.decline')}
          </button>
        </div>
      ) : (
        <div>
          <textarea
            className="form-control mb-2"
            rows={2}
            placeholder={t('copilot.confirm.reasonPlaceholder')}
            value={reason}
            onChange={(e) => setReason(e.target.value)}
          />
          <button
            type="button"
            className="btn btn-sm btn-danger"
            data-testid="copilot-decline-send"
            onClick={() => confirm(session.clientId, false, reason.trim() || undefined)}
          >
            {t('copilot.confirm.sendDecline')}
          </button>
        </div>
      )}
    </div>
  )
}
